const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY_URL,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_AFTER_LOGIN_URL,
  response_type: "code",
  scope: "email openid profile",
};

const signOutRedirect = (): void => {
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
  const logoutUri = process.env.REACT_APP_SIGN_OUT_URL || "";
  const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;
  window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
};

export { cognitoAuthConfig, signOutRedirect }
